<script setup lang="ts">
import type { SimulatedImage } from '../../types/chat'

withDefaults(defineProps<{
  images: SimulatedImage[]
  side?: 'left' | 'right'
  fullWidth?: boolean
  descriptionClass?: string
  descriptionStyle?: Record<string, string>
}>(), {
  side: 'left',
  fullWidth: false,
})
</script>

<template>
  <div class="simulated-image-grid" :class="[`simulated-image-grid-${side}`, { 'simulated-image-grid-full': fullWidth }]">
    <figure v-for="(image, index) in images" :key="`${index}-${image.description}`" class="simulated-image-card">
      <div
        class="simulated-image-canvas flex flex-col items-center justify-center border-2 border-neutral-300 rounded-lg border-dashed p-4 dark:border-neutral-700"
        role="img"
        :aria-label="image.description"
      >
        <div class="simulated-image-icon i-solar:gallery-bold mb-2 text-4xl text-neutral-400 dark:text-neutral-500" aria-hidden="true" />
        <div
          class="simulated-image-description"
          :class="descriptionClass || 'simulated-image-description-default text-center text-xs text-neutral-500 italic dark:text-neutral-400'"
          :style="descriptionStyle"
        >
          {{ image.description }}
        </div>
      </div>
    </figure>
  </div>
</template>

<style scoped>
.simulated-image-grid {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 8px;
  width: min(100%, 360px);
}

.simulated-image-grid:has(> :nth-child(2)) {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.simulated-image-grid-full {
  width: 100%;
}

.simulated-image-card {
  min-width: 0;
  margin: 0;
  overflow: hidden;
}

.simulated-image-canvas {
  min-height: 192px;
}

.simulated-image-description.chat-plain-text {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
}

@media (max-width: 420px) {
  .simulated-image-grid {
    width: min(100%, 300px);
  }

  .simulated-image-grid-full {
    width: 100%;
  }

  .simulated-image-canvas {
    min-height: 192px;
  }
}
</style>
